import React from "react";

const CausalIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2785_802)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.0001 40C31.0458 40 40 31.0458 40 20C40 8.9543 31.0458 0 20.0001 0C8.9543 0 0 8.9543 0 20C0 31.0458 8.9543 40 20.0001 40ZM20.0001 32.5234C26.9164 32.5234 32.5234 26.9165 32.5234 20C32.5234 13.0835 26.9164 7.47665 20.0001 7.47665C13.0836 7.47665 7.47663 13.0835 7.47663 20C7.47663 26.9165 13.0836 32.5234 20.0001 32.5234Z",
  fill: "#C3D9F3"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2785_802"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(CausalIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;